import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { BankSelectorViewModel } from "src/erp/arap/rawData/bank/bankSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import  { BankBranchManipulationView } from "./bankBranchManipulation-view"

export class BankBranchManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت شعبه های بانک';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.bankBranch = ObservableArray.create<bankBranch>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new BankBranchManipulationView();
    }
    public getTypeId(): string {
        return "VM-E5F9144F-0C41-4790-9BA9-1917686C177C"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set bankBranch(v: ObservableArray<bankBranch>) { this._bankBranch = v; } public get bankBranch(): ObservableArray<bankBranch> { return this._bankBranch;} private _bankBranch: ObservableArray<bankBranch>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/GetAllBankBranch',{
                FilteringInformation:filteringInformation
            });
            let rowNumber = 1;
            this.bankBranch.update(...result.BankBranch.map(q=>{
                let r = new bankBranch(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.bankId = q.BankId;
                r.bankName = q.BankName;
                r.name = q.Name;            
                r.code = q.Code;            
                r.address = q.Address;            
                r.isMock = q.IsMock;            
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestBankBranchCreation(){
        let editor = new bankBranchEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    
    async bankBranchUpdater(bankBranch:bankBranch){
        let editor = new bankBranchEditor(this,new UpdateServerUpdater());
        bankBranch.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
}

export class bankBranch extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:BankBranchManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = getAsNumber(v, true); } public get code(): string { return this._code;} private _code: string;
    public set isMock(v: boolean) { this._isMock = v; } public get isMock(): boolean { return this._isMock;} private _isMock: boolean;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address;} private _address: string;
    
    public set bankName(v: string) { this._bankName = v; } public get bankName(): string { return this._bankName;} private _bankName: string;
    public set bankId(v: string) { this._bankId = v; } public get bankId(): string { return this._bankId;} private _bankId: string;
    
    private _typedParent:BankBranchManipulationViewModel;

    cloneTo(bankBranch:bankBranch){
        bankBranch.id = this.id;
        bankBranch.name = this.name;
        bankBranch.code = this.code;
        bankBranch.address = this.address;
        bankBranch.isMock = this.isMock;
        bankBranch.setBank(this.getBankId(), this.bankName);
    }

    setBank(id: string, name: string) {
        this.bankId = id;
        this.bankName = name;
    }
    getBankId() {
        return this.bankId;
    }
    
    async edit(){
        this._typedParent.bankBranchUpdater(this);
    }  
}

interface IServerUpdater{
    execute(bankBranch:bankBranch):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return ' شعبه بانک با موفقیت ثبت شد.';
    }
    async execute(bankBranch: bankBranch): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/CreateBankBranch',{
            Bank:bankBranch.getBankId(),
            Name:bankBranch.name,
            Code:bankBranch.code,
            IsMock:bankBranch.isMock,
            Address:bankBranch.address,
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'شعبه بانک با موفقیت به روز رسانی شد.';
    }
    async execute(bankBranch: bankBranch): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/UpdateBankBranch',{
            Id:bankBranch.id,
            Bank:bankBranch.getBankId(),
            Name:bankBranch.name,
            Code:bankBranch.code,
            Address:bankBranch.address,
            IsMock:bankBranch.isMock,
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class bankBranchEditor extends bankBranch implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:BankBranchManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.bankSelector = new BankSelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set bankSelector(v: BankSelectorViewModel) { this._bankSelector = v; } public get bankSelector(): BankSelectorViewModel { return this._bankSelector;} private _bankSelector: BankSelectorViewModel;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push(' نام شعبه بانک مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getBankId())){
            result.push(' بانک مشخص نشده است.')
        }
        return result;
    }

    setBank(id: string, name: string) {
        this.bankSelector.selectById(id);
    }

    getBankId() {
        return this.bankSelector.selectedItem?.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت شعبه بانک');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}

export class BankBranchSelectorViewModel extends SelectorBaseViewModel<BankBranchForSelector>{

    public set bankId(v: string) {
        this._bankId = v; 
        this.refresh();    
    } public get bankId(): string { return this._bankId;} private _bankId: string;
    
    protected async loadData(): Promise<BankBranchForSelector[]> {
        if(stringIsNullOrEmpty(this.bankId)){
            return Promise.resolve<BankBranchForSelector[]>([]);
        }
        let result = await ServerConnection.callServer('/Complex/ArapRawDataServices/GetBankBranchByBank',{
            Bank:this.bankId
        });
        return result.BankBranch.map(q=>{
            let result = new BankBranchForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

class BankBranchForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}

